import { render, staticRenderFns } from "./FormBuilderTemplateDetailCard.vue?vue&type=template&id=87203d80&scoped=true&"
import script from "./FormBuilderTemplateDetailCard.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderTemplateDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./FormBuilderTemplateDetailCard.vue?vue&type=style&index=0&id=87203d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87203d80",
  null
  
)

export default component.exports